import { render } from "./VietnamPage.vue?vue&type=template&id=ce881ac6&scoped=true"
import script from "./VietnamPage.vue?vue&type=script&lang=js"
export * from "./VietnamPage.vue?vue&type=script&lang=js"

import "./VietnamPage.vue?vue&type=style&index=0&id=ce881ac6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce881ac6"]])

export default __exports__